import { render, staticRenderFns } from "./BlockCanvasReadonly.vue?vue&type=template&id=121c7372&scoped=true"
import script from "./BlockCanvasReadonly.vue?vue&type=script&lang=js"
export * from "./BlockCanvasReadonly.vue?vue&type=script&lang=js"
import style0 from "./BlockCanvasReadonly.vue?vue&type=style&index=0&id=121c7372&prod&lang=css"
import style1 from "./BlockCanvasReadonly.vue?vue&type=style&index=1&id=121c7372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121c7372",
  null
  
)

export default component.exports